
  document.addEventListener('DOMContentLoaded', function() {
    // ======= 🎬 CARICAMENTO FLUIDO INIZIALIZZAZIONE ======= //
    
    // Rimuove classe loading e attiva caricamento fluido
    document.documentElement.classList.remove('loading');
    
    // Attiva l'animazione di caricamento dell'header
    setTimeout(() => {
      document.body.classList.add('header-loaded');
    }, 100);
    
    // ======= DEFINIZIONE VARIABILI PRINCIPALI ======= //
    const header = document.querySelector('.premium-header') || document.querySelector('.Header');
    const headerSection = document.querySelector('.shopify-section--header') || document.getElementById('shopify-section-header');
    const cartIcon = document.querySelector('.cart-icon-wrapper');
    const menuButtons = document.querySelectorAll('[data-action="open-drawer"][data-drawer-id="sidebar-menu"]');

    // ======= 🔥 IMPOSTAZIONE DINAMICA DELL'ALTEZZA HEADER ======= //
    function setHeaderHeight() {
      if (headerSection) {
        const headerHeight = headerSection.offsetHeight;
        document.documentElement.style.setProperty('--header-height', headerHeight + 'px');
        
        // ✅ AGGIORNA IL PADDING DEL BODY IN TEMPO REALE
        const isTransparent = header && header.classList.contains('Header--transparent');
        if (!isTransparent) {
          document.body.style.paddingTop = headerHeight + 'px';
        } else {
          document.body.style.paddingTop = '';
        }
      }
    }
    
    // Imposta l'altezza iniziale
    setHeaderHeight();
    
    // Aggiorna l'altezza al ridimensionamento della finestra
    window.addEventListener('resize', function() {
      clearTimeout(window.headerResizeTimeout);
      window.headerResizeTimeout = setTimeout(setHeaderHeight, 100);
    });
    
    // ======= FUNZIONALITÀ PERFEZIONATA: SCROLL INTERNA NEI DROPDOWN ======= //
    function setupDropdownInternalScroll() {
      const dropdowns = document.querySelectorAll('.DropdownMenu, .MegaMenu');
      
      dropdowns.forEach(dropdown => {
        const scrollContainer = dropdown.querySelector('.Linklist, .MegaMenu__Inner');
        if (!scrollContainer) return;
        
        const items = scrollContainer.querySelectorAll('.Linklist__Item, .MegaMenu__Item');
        const itemCount = items.length;
        
        // Se ci sono più di 20 elementi (5 righe x 4 colonne), attiva scroll interno
        if (itemCount > 20) {
          // Forza il contenimento del dropdown principale
          dropdown.style.setProperty('overflow', 'hidden', 'important');
          dropdown.style.setProperty('max-height', 'var(--dropdown-max-height)', 'important');

          // Attiva scroll nel contenitore interno
          scrollContainer.style.setProperty('max-height', 'calc(var(--dropdown-max-height) - 40px)', 'important');
          scrollContainer.style.setProperty('overflow-y', 'auto', 'important');
          scrollContainer.style.setProperty('overflow-x', 'hidden', 'important');
          scrollContainer.style.setProperty('scrollbar-width', 'auto', 'important');
          scrollContainer.style.setProperty('padding', '4px', 'important');
        }
      });
    }
    
    // Applica scroll interna quando i dropdown diventano visibili
    const navItems = document.querySelectorAll('.nav-item[aria-haspopup="true"]');
    
    navItems.forEach(item => {
      item.addEventListener('mouseenter', function() {
        setTimeout(setupDropdownInternalScroll, 100); // Aspetta che l'animazione finisca
      });
    });
    
    // ======= STICKY HEADER SEMPLIFICATO CON LOGO SCALING ======= //
    // Verifica se il sticky header è abilitato nelle impostazioni
    const headerElement = document.querySelector('[data-section-type="header"]');
    let isStickyEnabled = false;

    if (headerElement) {
      const sectionSettings = headerElement.getAttribute('data-section-settings');
      if (sectionSettings) {
        try {
          const settings = JSON.parse(sectionSettings);
          isStickyEnabled = settings.isSticky === true;
        } catch (e) {
          // Errore parsing silenzioso
        }
      }
    }

    if (isStickyEnabled) {
      let lastScroll = 0;

      function stickyHeaderWithLogoScaling() {
        const currentScroll = window.pageYOffset;
        const header = document.querySelector('header') || document.querySelector('.Header') || document.querySelector('[data-section-type="header"]');
        const progressBar = document.querySelector('.header-accent-line');
        const logo = document.querySelector('.Header__LogoImage');
        const headerWrapper = document.querySelector('.Header__Wrapper');

        if (!header) return;

        // Barra di progressione verde
        if (progressBar) {
          const docHeight = document.documentElement.scrollHeight - window.innerHeight;
          const progress = (currentScroll / docHeight) * 100;
          progressBar.style.width = Math.min(progress, 100) + '%';
        }

        // ✨ PARAMETRI OTTIMIZZATI PER HEADER ULTRA STRETTO
        const scrollTrigger = 30; // 🔥 RIDOTTO: da 40px a 30px (trigger ancora prima)
        const logoScaleReduced = 1.0; // Scaling quasi impercettibile
        const maxPaddingReduction = 0.4;

        // Scaling BINARIO del logo - si riduce una sola volta e rimane fisso
        if (logo) {
          // ✅ DESKTOP: Logo grosso che si riduce con sticky
          if (window.innerWidth >= 768) {
            if (currentScroll > scrollTrigger) {
              logo.style.transform = `scale(1.6)`;
            } else {
              logo.style.transform = 'scale(1.9)';
            }
          } else {
            // 📱 MOBILE: Logo grande e visibile, abbassato (header invariato)
            if (currentScroll > scrollTrigger) {
              logo.style.transform = 'scale(1.7) translateY(4px)';
            } else {
              logo.style.transform = 'scale(1.9) translateY(6px)';
            }
          }
          logo.style.transformOrigin = 'center center';
          logo.style.transition = 'transform 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94)';
        }

        // ✨ RIDUZIONE PADDING ULTRA AGGRESSIVA
        if (headerWrapper) {
          if (currentScroll > scrollTrigger) {
            // 🔥 STICKY ULTRA STRETTO: 2px sopra, 1px sotto
            headerWrapper.style.paddingTop = '2px';
            headerWrapper.style.paddingBottom = '1px';
          } else {
            // 🔥 NORMALE STRETTO: 3px sopra, 2px sotto
            headerWrapper.style.paddingTop = '3px';
            headerWrapper.style.paddingBottom = '2px';
          }
          headerWrapper.style.transition = 'padding 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94)';
        }

        // Aggiunge classe per eventuali altri stili
        if (currentScroll > 30) { // 🔥 TRIGGER RIDOTTO: da 40 a 30
          header.classList.add('is-sticky');
        } else {
          header.classList.remove('is-sticky');
        }

        // ✅ AGGIORNA IL PADDING DEL BODY IN TEMPO REALE CON LO STICKY
        const isTransparent = header.classList.contains('Header--transparent');
        if (!isTransparent) {
          const headerHeight = header.offsetHeight;
          document.body.style.paddingTop = headerHeight + 'px';
        } else {
          document.body.style.paddingTop = '';
        }

        lastScroll = currentScroll;
      }

      // Event listener ottimizzato per performance
      let ticking = false;

      function requestStickyUpdate() {
        if (!ticking) {
          requestAnimationFrame(stickyHeaderWithLogoScaling);
          ticking = true;
          setTimeout(() => {
            ticking = false;
          }, 16); // 60fps
        }
      }

      window.addEventListener('scroll', requestStickyUpdate, { passive: true });

      // Attiva sticky header
      setTimeout(stickyHeaderWithLogoScaling, 500);
    }

    // ======= MOBILE LOGO SCALING (SEMPRE ATTIVO) ======= //
    // Questo codice funziona indipendentemente dallo sticky header
    (function() {
      function scaleMobileLogo() {
        const logo = document.querySelector('.Header__LogoImage');
        const isMobile = window.innerWidth < 768;

        if (logo && isMobile) {
          logo.style.transform = 'scale(1.9) translateY(6px)';
          logo.style.transformOrigin = 'center center';
          logo.style.transition = 'transform 0.3s ease';
        }
      }

      // Esegui subito
      scaleMobileLogo();

      // Esegui anche dopo che il DOM è completamente caricato
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', scaleMobileLogo);
      }

      // Esegui anche dopo un breve delay (per elementi caricati dinamicamente)
      setTimeout(scaleMobileLogo, 500);
      setTimeout(scaleMobileLogo, 1500);

      // Aggiorna al resize
      window.addEventListener('resize', function() {
        clearTimeout(window.mobileLogoResizeTimeout);
        window.mobileLogoResizeTimeout = setTimeout(scaleMobileLogo, 100);
      }, { passive: true });
    })();

    // ======= MOBILE ICONS SCALING (SEMPRE ATTIVO) ======= //
    (function() {
      function scaleMobileIcons() {
        const isMobile = window.innerWidth < 768;
        const icons = document.querySelectorAll('.Header__Icon');

        if (isMobile && icons.length > 0) {
          icons.forEach(function(icon, index) {
            // Icona 24px con piccolo margine tra icone
            icon.style.setProperty('--header-icon-size', '24px', 'important');
            icon.style.setProperty('margin-left', '4px', 'important');
            icon.style.setProperty('margin-right', '4px', 'important');
            icon.style.setProperty('min-width', '24px', 'important');
            icon.style.setProperty('min-height', '24px', 'important');

            // SVG interno con !important
            const svg = icon.querySelector('svg');
            if (svg) {
              svg.style.setProperty('width', '24px', 'important');
              svg.style.setProperty('height', '24px', 'important');
              svg.style.setProperty('min-width', '24px', 'important');
              svg.style.setProperty('min-height', '24px', 'important');
            }

            // Icon interno con !important
            const innerIcon = icon.querySelector('.Icon');
            if (innerIcon) {
              innerIcon.style.setProperty('width', '24px', 'important');
              innerIcon.style.setProperty('height', '24px', 'important');
              innerIcon.style.setProperty('min-width', '24px', 'important');
              innerIcon.style.setProperty('min-height', '24px', 'important');
            }
          });

          // Forza margine 0 su hamburger e carrello (ai bordi)
          const hamburger = document.querySelector('.menu-icon');
          // Trova il carrello visibile (quello con dimensioni > 0)
          const allCarts = document.querySelectorAll('.cart-icon-wrapper');
          let cart = null;
          allCarts.forEach(c => {
            const rect = c.getBoundingClientRect();
            if (rect.width > 0 && rect.height > 0) {
              cart = c;
            }
          });
          const wrapper = document.querySelector('.Header__Wrapper');

          if (hamburger) {
            hamburger.style.setProperty('margin-left', '0', 'important');
          }
          if (cart) {
            cart.style.setProperty('margin-right', '0', 'important');
          }

          // Equalizza padding sul wrapper
          if (wrapper && hamburger && cart) {
            const hamburgerRect = hamburger.getBoundingClientRect();
            const cartRect = cart.getBoundingClientRect();
            const leftDist = Math.round(hamburgerRect.left);
            const rightDist = Math.round(window.innerWidth - cartRect.right);

            if (Math.abs(leftDist - rightDist) > 2) {
              if (rightDist > leftDist) {
                const diff = rightDist - leftDist;
                wrapper.style.setProperty('padding-left', (10 + diff) + 'px', 'important');
                wrapper.style.setProperty('padding-right', '10px', 'important');
              } else {
                const diff = leftDist - rightDist;
                wrapper.style.setProperty('padding-left', '10px', 'important');
                wrapper.style.setProperty('padding-right', (10 + diff) + 'px', 'important');
              }
            }
          }

          // Rimuovi padding da mobile-utilities
          const mobileUtils = document.querySelector('.mobile-utilities');
          if (mobileUtils) {
            mobileUtils.style.setProperty('padding-right', '0', 'important');
            mobileUtils.style.setProperty('margin-right', '0', 'important');
          }

          // Rimuovi padding da left-section
          const leftSection = document.querySelector('.left-section');
          if (leftSection) {
            leftSection.style.setProperty('padding-left', '0', 'important');
            leftSection.style.setProperty('margin-left', '0', 'important');
          }

        }
      }

      // Esegui dopo delay per assicurarsi che il DOM sia pronto
      setTimeout(scaleMobileIcons, 500);
      setTimeout(scaleMobileIcons, 1500);

      // Al resize
      window.addEventListener('resize', function() {
        clearTimeout(window.mobileIconsResizeTimeout);
        window.mobileIconsResizeTimeout = setTimeout(scaleMobileIcons, 100);
      }, { passive: true });
    })();

    // ======= FUNZIONALITÀ: CARICAMENTO IMMAGINI NEI MENU DROPDOWN ======= //
    
    // Cache per le immagini già caricate
    const imageCache = new Map();
    let imageLoadTimeout;
    
    // Funzione per ottenere l'immagine del prodotto
    async function getProductImage(url) {
      if (imageCache.has(url)) {
        return imageCache.get(url);
      }
      
      try {
        let apiUrl = url.replace(/\/$/, '') + '.json';
        let response = await fetch(apiUrl);
        
        if (!response.ok) {
          response = await fetch(url);
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
          
          const html = await response.text();
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          
          const productImage = doc.querySelector('img[data-src*="products"], img[src*="products"]');
          if (productImage) {
            const imageUrl = productImage.getAttribute('data-src') || productImage.getAttribute('src');
            const processedUrl = processImageUrlForMenu(imageUrl, '80x80');
            imageCache.set(url, processedUrl);
            return processedUrl;
          }
          
          return null;
        }
        
        const data = await response.json();
        
        if (data.product && data.product.featured_image) {
          const imageUrl = processImageUrlForMenu(data.product.featured_image, '80x80');
          imageCache.set(url, imageUrl);
          return imageUrl;
        } else if (data.product && data.product.images && data.product.images.length > 0) {
          const imageUrl = processImageUrlForMenu(data.product.images[0], '80x80');
          imageCache.set(url, imageUrl);
          return imageUrl;
        }
      } catch (error) {
        imageCache.set(url, null);
      }

      return null;
    }
    
    // Funzione per ottenere l'immagine della collezione
    async function getCollectionImage(url) {
      if (imageCache.has(url)) {
        return imageCache.get(url);
      }
      
      try {
        let apiUrl = url.replace(/\/$/, '') + '.json';
        let response = await fetch(apiUrl);
        
        if (!response.ok) {
          response = await fetch(url);
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
          
          const html = await response.text();
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          
          const collectionImage = doc.querySelector('img[data-src*="collections"], img[src*="collections"], .collection-hero img, .collection-banner img');
          if (collectionImage) {
            const imageUrl = collectionImage.getAttribute('data-src') || collectionImage.getAttribute('src');
            const processedUrl = processImageUrlForMenu(imageUrl, '80x80');
            imageCache.set(url, processedUrl);
            return processedUrl;
          }
          
          return null;
        }
        
        const data = await response.json();
        
        if (data.collection && data.collection.image) {
          const imageUrl = processImageUrlForMenu(data.collection.image, '80x80');
          imageCache.set(url, imageUrl);
          return imageUrl;
        }
      } catch (error) {
        imageCache.set(url, null);
      }

      return null;
    }

    async function getBlogArticleImage(url) {
      if (imageCache.has(url)) return imageCache.get(url);
      try {
        const response = await fetch(url + '.json');
        if (response.ok) {
          const data = await response.json();
          if (data.article && data.article.image && data.article.image.src) {
            const imageUrl = processImageUrlForMenu(data.article.image.src, '80x80');
            imageCache.set(url, imageUrl);
            return imageUrl;
          }
        }
      } catch (e) {}
      imageCache.set(url, null);
      return null;
    }

    async function getPageImage(url) {
      if (imageCache.has(url)) return imageCache.get(url);
      const pageIcons = {
        '/pages/informazioni-di-contatto': null,
        '/pages/traccia-spedizione': null,
        '/pages/faq': null
      };
      if (url in pageIcons) {
        imageCache.set(url, null);
        return null;
      }
      imageCache.set(url, null);
      return null;
    }

    // Funzione per processare l'URL dell'immagine per i menu
    function processImageUrlForMenu(imageUrl, size = '80x80') {
      if (!imageUrl) return '';
      
      if (typeof imageUrl === 'object' && imageUrl.src) {
        imageUrl = imageUrl.src;
      } else if (typeof imageUrl === 'object' && imageUrl.url) {
        imageUrl = imageUrl.url;
      }
      
      if (typeof imageUrl !== 'string') return '';
      
      if (imageUrl.includes('_' + size) || imageUrl.includes('cdn.shopify.com')) {
        return imageUrl;
      }
      
      const cleanUrl = imageUrl.split('?')[0];
      
      if (cleanUrl.includes('.')) {
        const parts = cleanUrl.split('.');
        const extension = parts.pop();
        const baseUrl = parts.join('.');
        
        if (baseUrl.match(/_\d+x\d+$/)) {
          const baseWithoutSize = baseUrl.replace(/_\d+x\d+$/, '');
          return `${baseWithoutSize}_${size}.${extension}`;
        }
        
        return `${baseUrl}_${size}.${extension}`;
      }
      
      return imageUrl;
    }
    
    // Funzione per caricare le immagini nei link del menu
    let menuImagesLoaded = false;
    async function loadMenuImages() {
      if (menuImagesLoaded) return;
      menuImagesLoaded = true;
      const menuLinks = document.querySelectorAll('.menu-link-with-image');
      
      for (const link of menuLinks) {
        const url = link.getAttribute('data-menu-url');
        const title = link.getAttribute('data-menu-title');
        const imageContainer = link.querySelector('.menu-link-image-container');
        const placeholder = link.querySelector('.menu-link-image-placeholder');
        
        if (!url || !imageContainer || !placeholder) continue;


        placeholder.innerHTML = '<div class="menu-link-image-loading"></div>';

        let imageUrl = null;

        if (url.includes('/products/')) {
          imageUrl = await getProductImage(url);
        } else if (url.includes('/collections/')) {
          imageUrl = await getCollectionImage(url);
        } else if (url.includes('/blogs/')) {

          imageUrl = await getBlogArticleImage(url);

        } else if (url.includes('/pages/')) {

          imageUrl = await getPageImage(url);
        } else {

        }

        if (imageUrl) {
          placeholder.innerHTML = `<img src="${imageUrl}" alt="${title}" class="menu-link-image" loading="lazy">`;
          placeholder.classList.add('has-image');

        } else {
          // Icone SVG fallback per voci menu senza immagine
          const iconMap = {
            'contattaci': '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"/></svg>',
            'traccia la tua spedizione': '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><rect x="1" y="3" width="15" height="13" rx="2"/><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg>',
            'faq': '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>'
          };
          const titleLower = (title || '').toLowerCase().trim();
          const svgIcon = iconMap[titleLower];
          if (svgIcon) {
            placeholder.innerHTML = svgIcon;
            placeholder.classList.add('has-icon');
          } else {
            placeholder.innerHTML = '';
          }

        }
      }
    }
    
    // Carica le immagini quando si apre un dropdown
    function loadImagesOnHover() {
      const navItems = document.querySelectorAll('.nav-item[aria-haspopup="true"]');
      
      navItems.forEach(item => {
        item.addEventListener('mouseenter', function() {
          clearTimeout(imageLoadTimeout);
          imageLoadTimeout = setTimeout(() => {
            const dropdown = item.querySelector('.DropdownMenu, .MegaMenu');
            if (dropdown) {
              const menuLinks = dropdown.querySelectorAll('.menu-link-with-image');
              if (menuLinks.length > 0) {
                loadMenuImages();
              }
            }
            
            setTimeout(setupDropdownInternalScroll, 300);
          }, 200);
        });
      });
    }
    
    // Inizializza il caricamento delle immagini sui dropdown
    loadImagesOnHover();
    
    // ======= SISTEMA DI POSIZIONAMENTO INTELLIGENTE DROPDOWN ======= //
    
    function positionDropdownIntelligently() {
      const navItems = document.querySelectorAll('.nav-item[aria-haspopup="true"]');
      
      navItems.forEach(item => {
        const dropdown = item.querySelector('.DropdownMenu, .MegaMenu');
        if (!dropdown) return;
        
        item.addEventListener('mouseenter', function() {
          dropdown.style.transform = '';
          dropdown.style.left = '';
          dropdown.style.right = '';

          setTimeout(() => {
            if (item.getAttribute('aria-expanded') === 'true') {
              const dropdownRect = dropdown.getBoundingClientRect();
              const viewportWidth = window.innerWidth;
              const headerRect = header.getBoundingClientRect();
              const itemRect = item.getBoundingClientRect();

              const dropdownWidth = dropdownRect.width;
              const itemCenter = itemRect.left + itemRect.width / 2;

              /* Calcola la posizione ideale: centrato sotto il menu item */
              let idealLeft = itemCenter - dropdownWidth / 2;

              /* Se esce a destra, sposta a sinistra */
              if (idealLeft + dropdownWidth > viewportWidth - 20) {
                idealLeft = viewportWidth - dropdownWidth - 20;
              }

              /* Se esce a sinistra, sposta a destra */
              if (idealLeft < 20) {
                idealLeft = 20;
              }

              /* Converti in posizione relativa al parent (nav-item) */
              const relativeLeft = idealLeft - itemRect.left;

              dropdown.style.left = relativeLeft + 'px';
              dropdown.style.right = 'auto';



              if (dropdown.classList.contains('MegaMenu')) {
                const maxWidth = Math.min(viewportWidth * 0.5, 800);
                dropdown.style.maxWidth = `${maxWidth}px`;
                dropdown.style.width = 'auto';
              }

              setTimeout(setupDropdownInternalScroll, 100);
            }
          }, 50);
        });
      });
    }
    
    // Inizializza il posizionamento intelligente
    positionDropdownIntelligently();
    
    // Riposiziona al ridimensionamento della finestra
    window.addEventListener('resize', function() {
      clearTimeout(window.resizeTimeout);
      window.resizeTimeout = setTimeout(() => {
        positionDropdownIntelligently();
        setupDropdownInternalScroll();
        setHeaderHeight(); // ✅ AGGIORNA ANCHE L'ALTEZZA HEADER
      }, 250);
    });
    
    // Gestione effetto hover menu migliorato con funzionalità dropdown
    navItems.forEach(item => {
      const link = item.querySelector('.nav-link');
      const hasDropdown = item.hasAttribute('aria-haspopup');
      let dropdown = null;
      
      if (hasDropdown) {
        dropdown = item.querySelector('.DropdownMenu') || item.querySelector('.MegaMenu');
      }
      
      if (link) {
        link.addEventListener('mouseenter', () => {
          navItems.forEach(otherItem => {
            if (otherItem !== item) {
              otherItem.style.opacity = '0.6';
            }
          });
        });
        
        link.addEventListener('mouseleave', () => {
          navItems.forEach(otherItem => {
            otherItem.style.opacity = '1';
          });
        });
      }
      
      if (hasDropdown) {
        let closeTimeout = null;

        item.addEventListener('mouseenter', () => {
          if (closeTimeout) { clearTimeout(closeTimeout); closeTimeout = null; }
          item.setAttribute('aria-expanded', 'true');
          if (dropdown) dropdown.setAttribute('aria-hidden', 'false');
        });

        item.addEventListener('mouseleave', () => {
          closeTimeout = setTimeout(() => {
            item.setAttribute('aria-expanded', 'false');
            if (dropdown) dropdown.setAttribute('aria-hidden', 'true');
          }, 250);
        });

        if (dropdown) {
          dropdown.addEventListener('mouseenter', () => {
            if (closeTimeout) { clearTimeout(closeTimeout); closeTimeout = null; }
            item.setAttribute('aria-expanded', 'true');
            dropdown.setAttribute('aria-hidden', 'false');
          });

          dropdown.addEventListener('mouseleave', () => {
            closeTimeout = setTimeout(() => {
              item.setAttribute('aria-expanded', 'false');
              dropdown.setAttribute('aria-hidden', 'true');
            }, 250);
          });
        }
      }
    });
    
    // Parallasse sul logo
    const logo = document.querySelector('[data-animate-logo]');
    if (logo) {
      window.addEventListener('scroll', function() {
        const scrollY = window.scrollY;
        if (scrollY < 100) {
          const translateY = scrollY * 0.05;
          logo.style.transform = `translateY(${translateY}px)`;
        }
      });
    }
    
    // ======= 🛒 AGGIORNAMENTO CARRELLO DESKTOP E MOBILE ======= //
    let updateCartInfoTimeout = null;
    let isUpdatingCart = false;

    function updateCartInfo() {
      // Debounce: se è già in esecuzione o c'è un timeout attivo, cancellalo
      if (updateCartInfoTimeout) {
        clearTimeout(updateCartInfoTimeout);
      }

      // Se è già in esecuzione, aspetta che finisca
      if (isUpdatingCart) return;

      // Esegui dopo 100ms (debounce)
      updateCartInfoTimeout = setTimeout(() => {
        doUpdateCartInfo();
      }, 100);
    }

    function doUpdateCartInfo() {
      if (isUpdatingCart) return;
      isUpdatingCart = true;

      // 🔥 AGGIORNA ELEMENTI DESKTOP E MOBILE
      const cartPriceElements = document.querySelectorAll('.cart-price');
      const cartBadges = document.querySelectorAll('.cart-badge');
      const cartCounts = document.querySelectorAll('.cart-count');

      // Fetch del carrello da Shopify
      fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
          // Calcola il prezzo totale considerando gli sconti bancale
          let totalPrice = 0;

          if (cart.items && cart.items.length > 0) {
            cart.items.forEach(item => {
              if (item.properties && item.properties['_Sconto Bancale'] === 'Attivo' && item.properties['_Prezzo Scontato Totale']) {
                const prezzoScontatoTotaleStr = item.properties['_Prezzo Scontato Totale'];
                const prezzoScontatoTotale = parseFloat(prezzoScontatoTotaleStr.replace('€', '').replace(/\./g, '').replace(',', '.'));
                totalPrice += prezzoScontatoTotale * 100;
              } else {
                totalPrice += item.line_price;
              }
            });
          } else {
            totalPrice = cart.total_price;
          }

          // Formatta il prezzo
          const _pp = (totalPrice / 100).toFixed(2).split('.');
          const formattedPrice = `${_pp[0].replace(/\B(?=(\d{3})+(?!\d))/g,'.')},${_pp[1]} €`;

          cartPriceElements.forEach(priceElement => {
            priceElement.textContent = formattedPrice;
          });

          // 🔥 BADGE CARRELLO DESKTOP E MOBILE
          cartBadges.forEach((badge, index) => {
            const count = cartCounts[index];

            if (cart.item_count > 0) {
              if (count) count.textContent = cart.item_count;
              badge.classList.add('has-items');
            } else {
              badge.classList.remove('has-items');
              if (count) count.textContent = '';
            }
          });

          isUpdatingCart = false;
        })
        .catch(error => {
          cartPriceElements.forEach(priceElement => {
            priceElement.textContent = '0,00 €';
          });
          cartBadges.forEach(badge => {
            badge.classList.remove('has-items');
            const count = badge.querySelector('.cart-count');
            if (count) count.textContent = '';
          });
          isUpdatingCart = false; // Reset flag
        });
    }
    
    // ======= 💖 GESTIONE WISHLIST DESKTOP E MOBILE ======= //
    function updateWishlistInfo() {
      // 🔥 AGGIORNA ELEMENTI DESKTOP E MOBILE
      const wishlistBadges = document.querySelectorAll('.wishlist-badge'); // Tutti i badge
      const wishlistCounts = document.querySelectorAll('.wishlist-count'); // Tutti i contatori
      
      let wishlistCount = 0;
      
      // Cerca fx-wishlist
      try {
        const fxWishlistData = localStorage.getItem('fx-wishlist');
        if (fxWishlistData) {
          const parsed = JSON.parse(fxWishlistData);
          if (Array.isArray(parsed)) {
            wishlistCount = parsed.length;
          }
        }

        if (wishlistCount === 0 && typeof window.getWishlist === 'function') {
          const globalWishlist = window.getWishlist();
          if (Array.isArray(globalWishlist)) {
            wishlistCount = globalWishlist.length;
          }
        }
      } catch (error) {
        // Errore silenzioso
      }
      
      // Backup keys
      if (wishlistCount === 0) {
        const backupKeys = [
          'wishlist', 'shopify-wishlist', 'favorites', 'wishlisted_products',
          'swym-wishlist', 'wishlist-king', 'smart-wishlist', 'growave-wishlist'
        ];
        
        for (const key of backupKeys) {
          try {
            const data = localStorage.getItem(key);
            if (data) {
              const parsed = JSON.parse(data);
              let count = 0;
              
              if (Array.isArray(parsed)) {
                count = parsed.length;
              } else if (parsed.items && Array.isArray(parsed.items)) {
                count = parsed.items.length;
              } else if (parsed.products && Array.isArray(parsed.products)) {
                count = parsed.products.length;
              }
              
              if (count > 0) {
                wishlistCount = Math.max(wishlistCount, count);
                break;
              }
            }
          } catch (error) {
            // Continua
          }
        }
      }

      // Conta DOM solo se siamo in wishlist page
      if (wishlistCount === 0 && window.location.pathname.includes('wishlist')) {
        const wishlistSelectors = [
          '.fx-product-standard-card', '.wishlist-item', '.wishlist-product'
        ];

        for (const selector of wishlistSelectors) {
          const elements = document.querySelectorAll(selector);
          if (elements.length > 0) {
            wishlistCount = Math.max(wishlistCount, elements.length);
            break;
          }
        }
      }

      // 🔥 AGGIORNA BADGE WISHLIST DESKTOP E MOBILE
      wishlistBadges.forEach((badge, index) => {
        const count = wishlistCounts[index];

        if (wishlistCount > 0) {
          if (count) count.textContent = wishlistCount;
          badge.classList.add('has-items');
        } else {
          badge.classList.remove('has-items');
          if (count) count.textContent = '';
        }
      });

      return wishlistCount;
    }
    
    // ======= 💪 SISTEMA MONITORAGGIO WISHLIST DESKTOP E MOBILE ======= //
    function initAdvancedWishlistMonitoring() {
      let lastWishlistCount = 0;
      
      function checkFxWishlistChanges() {
        try {
          let currentCount = 0;
          
          if (typeof window.getWishlist === 'function') {
            const globalWishlist = window.getWishlist();
            currentCount = Array.isArray(globalWishlist) ? globalWishlist.length : 0;
          } else {
            const fxWishlistData = localStorage.getItem('fx-wishlist');
            if (fxWishlistData) {
              const parsed = JSON.parse(fxWishlistData);
              currentCount = Array.isArray(parsed) ? parsed.length : 0;
            }
          }
          
          if (currentCount !== lastWishlistCount) {
            lastWishlistCount = currentCount;
            updateWishlistInfo();
          }
        } catch (error) {
          // Ignora errori
        }
      }
      
      // Controllo ogni 2 secondi
      setInterval(checkFxWishlistChanges, 2000);
      
      // Monitoraggio mutazioni DOM per pagina wishlist
      if (window.location.pathname.includes('wishlist')) {
        const observer = new MutationObserver(function(mutations) {
          let shouldUpdate = false;
          
          mutations.forEach(function(mutation) {
            if (mutation.type === 'childList') {
              mutation.addedNodes.forEach(function(node) {
                if (node.nodeType === 1 && (
                  (node.classList && node.classList.contains('fx-product-standard-card')) ||
                  (node.querySelector && node.querySelector('.fx-product-standard-card'))
                )) {
                  shouldUpdate = true;
                }
              });
              
              mutation.removedNodes.forEach(function(node) {
                if (node.nodeType === 1 && (
                  (node.classList && node.classList.contains('fx-product-standard-card'))
                )) {
                  shouldUpdate = true;
                }
              });
            }
          });
          
          if (shouldUpdate) {
            setTimeout(updateWishlistInfo, 200);
          }
        });

        const wishlistGrid = document.getElementById('wishlist-products-grid');
        if (wishlistGrid) {
          observer.observe(wishlistGrid, {
            childList: true,
            subtree: true
          });
        }
      }

      // Storage events
      window.addEventListener('storage', function(e) {
        if (e.key === 'fx-wishlist') {
          setTimeout(updateWishlistInfo, 100);
        }
      });

      // Eventi personalizzati
      const wishlistEvents = [
        'wishlist:updated', 'wishlist:added', 'wishlist:removed',
        'fx:wishlist:updated', 'fx:wishlist:added', 'fx:wishlist:removed'
      ];

      wishlistEvents.forEach(event => {
        document.addEventListener(event, function() {
          setTimeout(updateWishlistInfo, 100);
        });
      });

      // Intercetta funzioni globali
      if (typeof window.addToWishlist === 'function' || typeof window.removeFromWishlist === 'function') {
        
        if (typeof window.addToWishlist === 'function') {
          const originalAdd = window.addToWishlist;
          window.addToWishlist = function(...args) {
            const result = originalAdd.apply(this, args);
            setTimeout(updateWishlistInfo, 200);
            return result;
          };
        }
        
        if (typeof window.removeFromWishlist === 'function') {
          const originalRemove = window.removeFromWishlist;
          window.removeFromWishlist = function(...args) {
            const result = originalRemove.apply(this, args);
            setTimeout(updateWishlistInfo, 200);
            return result;
          };
        }
      }
      
      // Intercetta clic wishlist
      document.addEventListener('click', function(e) {
        const wishlistButton = e.target.closest([
          '.fx-wishlist-button', '[data-wishlist-toggle]', '.wishlist-btn',
          '[data-action="add-to-wishlist"]', '[data-action="remove-from-wishlist"]',
          '.add-to-wishlist', '.remove-from-wishlist'
        ].join(', '));

        if (wishlistButton) {
          setTimeout(updateWishlistInfo, 300);
          setTimeout(updateWishlistInfo, 1000);
          setTimeout(updateWishlistInfo, 2000);
        }
      });

      // Focus window
      window.addEventListener('focus', function() {
        updateWishlistInfo();
      });

      // Cambio pagina
      let currentPath = window.location.pathname;
      setInterval(() => {
        if (window.location.pathname !== currentPath) {
          currentPath = window.location.pathname;
          setTimeout(updateWishlistInfo, 500);
        }
      }, 1000);
    }

// (funzione di test rimossa 06/08)


    // Esposizione funzioni globali
    window.updateWishlistInfo = updateWishlistInfo;
    
    // Inizializza carrello e wishlist
    updateCartInfo();
    updateWishlistInfo();
    
    // Attiva monitoraggio wishlist
    initAdvancedWishlistMonitoring();
    
    // ======= 🔄 EVENT LISTENERS CARRELLO ======= //
    
    // Eventi carrello Shopify
    document.addEventListener('cart:refresh', updateCartInfo);
    document.addEventListener('cart:update', updateCartInfo);
    document.addEventListener('cart.requestComplete', updateCartInfo);
    document.addEventListener('product:added', updateCartInfo);
    document.addEventListener('cart:item-added', updateCartInfo);
    document.addEventListener('cart:item-removed', updateCartInfo);
    document.addEventListener('cart:item-updated', updateCartInfo);
    
    // Intercetta AJAX carrello
    // KH-FIX 2026-09-26: intercetta anche XHR (il cart drawer usa /cart/change.js via XHR) per aggiornare subito il contatore
    (function(){
      var _open = XMLHttpRequest.prototype.open;
      XMLHttpRequest.prototype.open = function(method, url){
        try {
          if (typeof url === 'string' && (url.indexOf('/cart/add')>-1 || url.indexOf('/cart/change')>-1 || url.indexOf('/cart/update')>-1 || url.indexOf('/cart/clear')>-1)) {
            this.addEventListener('load', function(){ setTimeout(updateCartInfo, 300); });
          }
        } catch(e){}
        return _open.apply(this, arguments);
      };
    })();
    const originalFetch = window.fetch;
    window.fetch = function(...args) {
      const promise = originalFetch.apply(this, args);
      
      if (args[0] && (
        args[0].includes('/cart/add') || 
        args[0].includes('/cart/change') || 
        args[0].includes('/cart/update') ||
        args[0].includes('/cart/clear') ||
        false /* KH-FIX: /cart.js rimosso, causava loop di polling infinito */
      )) {
        promise.then(() => {
          setTimeout(updateCartInfo, 500);
        });
      }
      
      return promise;
    };
    
    // Intercetta pulsanti carrello
    document.addEventListener('click', function(e) {
      const addToCartButton = e.target.closest('[data-action="add-to-cart"], .add-to-cart, [name="add"], .btn-addtocart, .product-form__cart-submit');
      if (addToCartButton) {
        setTimeout(updateCartInfo, 1000);
        setTimeout(updateCartInfo, 2000);
      }
    });
    
    // Intercetta form carrello
    document.addEventListener('submit', function(e) {
      if (e.target.action && e.target.action.includes('/cart/add')) {
        setTimeout(updateCartInfo, 1000);
      }
    });
    
    // Aggiorna ogni 15 secondi
    setInterval(updateCartInfo, 15000);
    
    // Focus window
    window.addEventListener('focus', function() {
      updateCartInfo();
      updateWishlistInfo();
    });

    // Touch events per mobile
    if ('ontouchstart' in window) {
      const touchableElements = document.querySelectorAll('.Icon-Wrapper--clickable, .nav-link, .Link--secondary');
      
      touchableElements.forEach(el => {
        el.addEventListener('touchstart', function() {
          this.classList.add('touch-active');
        }, { passive: true });
        
        el.addEventListener('touchend', function() {
          this.classList.remove('touch-active');
        }, { passive: true });
      });
    }
    
    // ======= GESTIONE MODALE MOBILE - ADATTATA PER SAFE AREAS ======= //
    const mobileSearchIcon = document.querySelector('.mobile-search-left');
    const mobileSearchModal = document.getElementById('mobileSearchModal');
    const mobileSearchModalClose = document.querySelector('.mobile-search-modal-close');
    const mobileSearchModalOverlay = document.querySelector('.mobile-search-modal-overlay');
    let updateViewport = null; // KH: scope condiviso open/close (fix ReferenceError)
    
    // Apri modale ricerca mobile
    if (mobileSearchIcon) {
      mobileSearchIcon.addEventListener('click', function() {
        if (mobileSearchModal) {
          mobileSearchModal.classList.add('active');
          
          // Previene scrolling del body
          document.body.style.overflow = 'hidden';
          
          // Adatta alla viewport height dinamica
          if (window.visualViewport) {
            updateViewport = () => {
              const vh = window.visualViewport.height;
              mobileSearchModal.style.height = `${vh}px`;
            };
            
            updateViewport();
            window.visualViewport.addEventListener('resize', updateViewport);
          }
          
          if (window.navigator && window.navigator.vibrate) {
            window.navigator.vibrate(50);
          }
        }
      });
    }
    
    // Chiudi modale con pulsante X
    if (mobileSearchModalClose) {
      mobileSearchModalClose.addEventListener('click', function() {
        if (mobileSearchModal) {
          mobileSearchModal.classList.remove('active');
          document.body.style.overflow = '';
          
          // Rimuovi listener viewport se presente
          if (window.visualViewport) {
            window.visualViewport.removeEventListener('resize', updateViewport);
          }
          
          if (window.navigator && window.navigator.vibrate) {
            window.navigator.vibrate(30);
          }
        }
      });
    }
    
    // Chiudi modale con overlay
    if (mobileSearchModalOverlay) {
      mobileSearchModalOverlay.addEventListener('click', function() {
        if (mobileSearchModal) {
          mobileSearchModal.classList.remove('active');
          document.body.style.overflow = '';
          
          // Rimuovi listener viewport se presente
          if (window.visualViewport) {
            window.visualViewport.removeEventListener('resize', updateViewport);
          }
        }
      });
    }
    
    // ESC per chiudere
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && mobileSearchModal && mobileSearchModal.classList.contains('active')) {
        mobileSearchModal.classList.remove('active');
        document.body.style.overflow = '';
        
        if (window.visualViewport) {
          window.visualViewport.removeEventListener('resize', updateViewport);
        }
      }
    });
    
    // Gestione orientamento schermo
    window.addEventListener('orientationchange', function() {
      if (mobileSearchModal && mobileSearchModal.classList.contains('active')) {
        setTimeout(() => {
          if (window.visualViewport) {
            const vh = window.visualViewport.height;
            mobileSearchModal.style.height = `${vh}px`;
          }
        }, 100);
      }
    });

    // ======= 🔄 RIAPPLICA AL CAMBIO ORIENTAMENTO ======= //
    window.addEventListener('orientationchange', function() {
      setTimeout(() => {
        setHeaderHeight();
      }, 500);
    });
  });
